import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AccountSettingsDataService } from 'app/shared/services/account-settings-data-service';
import { AuthenticationService } from 'app/core/authentication';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';
import { StudentBtnSizeOption } from 'app/student/components/student-btn/student-btn-size-option';
import { StudentBtnTypeOption } from 'app/student/components/student-btn/student-btn-type-option';
import { tap } from 'rxjs/operators';
import { TranslationService } from 'app/core/internationalization/translation.service';

@Component({
    template: '',
    standalone: false
})
export abstract class DeleteAccountModal {
  public deleteText = '';
  public confirmationText = '';
  public deleteAccountForm!: FormGroup;

  public btnSizes = StudentBtnSizeOption;
  public btnTypes = StudentBtnTypeOption;

  public deleteAccountFormFields = {
    confirmation: 'confirmation'
  }

  public constructor(protected readonly bsModalRef: BsModalRef,
      protected readonly translationService: TranslationService,
      protected readonly formBuilder: FormBuilder,
      protected readonly accountSettingsDataService: AccountSettingsDataService,
      protected readonly authenticationService: AuthenticationService) { }

  public ngOnInit(): void {
    this.deleteText = this.translationService.instant('TEACHER_DELETE_ACCOUNT_MODAL.DELETE');
    this.deleteAccountForm = this.createForm();
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

  public createForm(): FormGroup {
    return this.formBuilder.group({
      [this.deleteAccountFormFields.confirmation]: this.formBuilder.control('', [Validators.required, this.deleteTextValidator])
    });
  }

  public deleteAccount():void {
    this.accountSettingsDataService.deleteUser()
      .pipe(
        tap( () => this.authenticationService.logOut()))
      .subscribe();
  }

public getPlaceholder(): string {
  return this.translationService.instant(
    'TEACHER_DELETE_ACCOUNT_MODAL.TYPE_DELETETEXT',
    { deleteText: this.deleteText }
  );
}

  public isValid() {

    return this.deleteAccountForm.valid;
  }

  private deleteTextValidator = (control: AbstractControl): ValidationErrors | null => {
    if (control !== null) {
      if(control.dirty && control.value && (control.value as string).toUpperCase() !== this.deleteText.toUpperCase()) {
        control.setErrors({mismatch: true});
      } else {
        control.setErrors(null);
      }

      return control.errors;
    }

    return null;
  };
}
